import { getSizeStyles } from './size/getSizeStyles';
import { mergeStyles } from '../../../../../../../internal/utils/mergeStyles';
export function getTabletDesktopStyles(size) {
  const deviceStyles = require('./styles.module.css');
  const sizeStyles = getSizeStyles(size);
  return mergeStyles(deviceStyles, sizeStyles);
}